import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, AppProvider } from "./context/AppContext";

// Pages
import GroupLogin from "./pages/GroupLogin";
import OrderForm from "./pages/OrderForm";
import TripsPage from "./pages/TripsPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDietary from "./pages/AdminDietary";
import { 
  AdminLayout, 
  AdminDashboard, 
  AdminReports, 
  AdminSettings, 
  AdminSync,
  AdminTrips 
} from "./pages/AdminPages";

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Counselor Routes */}
              <Route path="/" element={<GroupLogin />} />
              <Route path="/order" element={<OrderForm />} />
              <Route path="/trips" element={<TripsPage />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="reports" element={<AdminReports />} />
                <Route path="trips" element={<AdminTrips />} />
                <Route path="dietary" element={<AdminDietary />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="sync" element={<AdminSync />} />
              </Route>
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster 
            position="top-center" 
            richColors 
            closeButton
            toastOptions={{
              style: {
                fontFamily: 'Inter, sans-serif',
              },
            }}
          />
          {/* Brian Stein Badge */}
          <div
            className="no-print"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 14px 6px 8px',
              borderRadius: '50px',
              background: '#2B4F8C',
              position: 'fixed',
              bottom: '16px',
              right: '16px',
              zIndex: 9999,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            }}
          >
            <img 
              src="/brian-logo.png" 
              alt="" 
              style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover', background: 'white' }} 
            />
            <span style={{ color: '#fff', fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap' }}>
              Made by Brian Stein
            </span>
          </div>
        </div>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
